import { CONSUMER_LOST_SHOPPER_SLIDES, SlidesByType } from '../constants';

import { UpsellCell } from './types';

const SlidesPerMarket: UpsellCell = {
  all: {
    [SlidesByType.CONSUMER_LOST_SHOPPER]: CONSUMER_LOST_SHOPPER_SLIDES,
  },
};

export default SlidesPerMarket;
